import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ImageUploadField, PageHeader, useToast } from 'components/admin';
import { Button, Checkbox, Input, Select } from 'components/common';
import { createIntroduceOrientation, getAdminIntroduceMenus, getAdminIntroduceOrientationById, updateIntroduceOrientation } from 'apis/adminIntroduce';
import {
    useAdminCreateMutation,
    useAdminDetailQuery,
    useAdminListQuery,
    useAdminUpdateMutation,
} from 'hooks';
import '../../../styles/admin-shared.scss';

const IntroduceOrientationsForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const toast = useToast();
    const [formData, setFormData] = useState({ introduceMenuId: '', image: '', sortOrder: 0, isActive: true });

    const { data: menuData = { items: [] } } = useAdminListQuery('introduce-menus-options', { pageSize: 1000, languageCode: 'vi' }, getAdminIntroduceMenus);
    const menus = menuData.items;
    const { data: detail, error: detailError } = useAdminDetailQuery('introduce-orientations', id, getAdminIntroduceOrientationById);
    const createMutation = useAdminCreateMutation('introduce-orientations', createIntroduceOrientation);
    const updateMutation = useAdminUpdateMutation('introduce-orientations', updateIntroduceOrientation);
    const loading = createMutation.isPending || updateMutation.isPending;

    useEffect(() => {
        if (detail) setFormData(detail);
    }, [detail]);

    useEffect(() => {
        if (detailError) toast.error(detailError.message || 'Tải dữ liệu thất bại');
    }, [detailError, toast]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const payload = { ...formData, sortOrder: Number(formData.sortOrder), introduceMenuId: Number(formData.introduceMenuId) };
            const res = id
                ? await updateMutation.mutateAsync({ id, data: payload })
                : await createMutation.mutateAsync(payload);
            if (res.success) { toast.success(id ? 'Cập nhật thành công' : 'Thêm mới thành công'); navigate('/admin/introduce-orientations'); }
            else { toast.error(res.message || 'Lưu thất bại'); }
        } catch { toast.error('Lưu thất bại'); }
    };

    return (
        <div className="admin-page">
            <PageHeader title={id ? 'Cập nhật Định hướng' : 'Thêm Định hướng mới'} />
            <form className="form-card" onSubmit={handleSubmit}>
                <p className="form-section-title">Thông tin chung</p>
                <div className="form-row">
                    <Select label="Menu Giới thiệu *" name="introduceMenuId" value={formData.introduceMenuId} onChange={handleChange} required options={[{ value: '', label: '— Chọn Menu —' }, ...menus.map(m => ({ value: m.id, label: m.name || m.title || `Menu #${m.id}` }))]} />
                    <Input label="Thứ tự hiển thị" name="sortOrder" type="number" value={formData.sortOrder} onChange={handleChange} />
                </div>
                <ImageUploadField
                    label="Hình ảnh định hướng *"
                    value={formData.image}
                    folder="introduce/orientations"
                    onChange={(image) => setFormData(prev => ({ ...prev, image }))}
                />
                <Checkbox label="Hoạt động" name="isActive" checked={formData.isActive} onChange={handleChange} />
                
                <div className="form-actions" style={{ marginTop: 24 }}>
                    <Button type="submit" disabled={loading}>{loading ? 'Đang lưu...' : id ? 'Cập nhật' : 'Thêm mới'}</Button>
                    <Button type="button" variant="secondary" onClick={() => navigate('/admin/introduce-orientations')}>Hủy</Button>
                </div>
            </form>
        </div>
    );
};

export default IntroduceOrientationsForm;
